export default __webpack_public_path__ + "static/marketIntegration1-7bf306a57264877688f5afe9f0fca2fe.jpg";